export default "__VITE_ASSET__955f072d__"